
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 585 585","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M286.857 3.256a2.9 2.9 0 00-2.982-2.848A292.228 292.228 0 10452.488 537.22a2.901 2.901 0 00.818-4.041 2.946 2.946 0 00-4.061-.822A286.38 286.38 0 0110.018 247.063 286.385 286.385 0 01283.995 6.253a2.946 2.946 0 002.862-2.997z","fill":"#EF3D26"}}),_c('path',{attrs:{"d":"M513.412 479.625a2.9 2.9 0 004.108-.349A292.227 292.227 0 00300.886.386a2.9 2.9 0 00-2.974 2.855 2.946 2.946 0 002.87 2.989 286.381 286.381 0 01275.6 326.03 286.387 286.387 0 01-63.319 143.236 2.946 2.946 0 00.349 4.129z","fill":"#00A586"}}),_c('path',{attrs:{"d":"M461.609 527.429a2.9 2.9 0 004.07.656 292.311 292.311 0 0037.95-33.257 2.9 2.9 0 00-.116-4.121 2.946 2.946 0 00-4.142.116 286.323 286.323 0 01-37.103 32.516 2.945 2.945 0 00-.659 4.09z","fill":"#0A7EBF"}})])
          )
        }
      }
    